import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Pages from '../Rubrics/Pages'
import Lists from '../Rubrics/Lists'
import Loader from '../UI/Loader'
import tools from '../../tools'

// Niveau 3 du drill-down /contenu : l'éditeur d'une catégorie (page ou liste), rhabillé (maquette v6)
class ContenuCategorie extends Component {
	constructor(props) {
		super(props)
		this.state = {
			category: null,
			group: null,
			icons: null,
			theme: null,
			current_lang: this.props.lang_default,
			not_found: false,
			error: null
		}
		this.props.updateNavbarTitle('Contenu de mon app')
	}

	componentDidMount() {
		this.loadCategorie()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id !== this.props.match.params.id)
		{
			this.setState({ category: null, group: null, not_found: false, error: null })
			this.loadCategorie()
		}
	}

	loadCategorie = () => {
		const category_id = this.props.match.params.id
		Promise.all([
			this.props.fetchCategories(),
			this.props.fetchGroups(),
			this.props.fetchIcons(),
			this.props.fetchTheme()
		])
		.then(([categories, groups, icons, theme]) => {
			let category = null
			for (let i = 0; i < categories.length; i++)
			{
				if (categories[i]._id === category_id)
				{
					category = categories[i]
					break
				}
			}
			if (!category)
			{
				this.setState({ not_found: true })
				return ;
			}
			let group = null
			for (let i = 0; i < groups.length; i++)
			{
				if (groups[i]._id === category.group)
				{
					group = groups[i]
					break
				}
			}
			this.setState({ category: category, group: group, icons: icons, theme: theme })
		})
		.catch(err => {
			this.setState({ error: tools.default_error_msg("Impossible de récupérer la catégorie", 1) })
			console.log(err)
		})
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	goContenu = () => {
		this.props.history.push('/contenu')
	}

	goRubrique = () => {
		if (this.state.group)
			this.props.history.push('/contenu/rubrique/' + this.state.group._id)
		else
			this.props.history.push('/contenu')
	}

	render() {
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.rubrics || permissions.rubrics === 0)
			return (<Redirect to="/" />)
		if (this.state.not_found === true)
			return (<Redirect to="/contenu" />)
		if (this.state.category === null)
		{
			if (this.state.error !== null)
				return (<p className="error center">{this.state.error}</p>)
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		const category = this.state.category
		const group = this.state.group
		const name = tools.getTranslationValue(category.translations, this.props.lang_default, 'name')
		const group_name = (group) ? tools.getTranslationValue(group.translations, this.props.lang_default, 'name') : null
		const icon = tools.getIconPreview(this.state.icons, category.icon, 'lineal', 'blank')
		const themeStyle = (this.state.theme && this.state.theme.color1) ? { backgroundColor: '#' + this.state.theme.color1 } : { backgroundColor: '#9CA3AF' }
		const is_list = (category.type === "list")
		return (
			<div className="wrapper-content">
				<p className="text-xs text-gray-400 mb-4 max-w-4xl">
					<Link to="/contenu" className="text-gray-500 hover:text-gray-900">Contenu de mon app</Link>
					{group_name &&
						<span>
							<span className="mx-2 text-gray-300">/</span>
							<Link to={"/contenu/rubrique/" + group._id} className="text-gray-500 hover:text-gray-900">{group_name}</Link>
						</span>
					}
					<span className="mx-2 text-gray-300">/</span>
					<span className="text-gray-900 font-semibold">{name}</span>
				</p>
				<div className="flex items-center flex-wrap max-w-4xl mb-5">
					<div className="w-11 h-11 rounded-xl flex-shrink-0 flex items-center justify-center" style={themeStyle}>
						{(icon) ? <img src={icon} className="w-6 h-6" alt="" /> : <span className="text-white text-base" aria-hidden="true">▭</span>}
					</div>
					<div className="flex-1 min-w-0 ml-4">
						<h2 className="text-lg font-bold tracking-tight text-gray-900 mb-0 truncate">{name}</h2>
						<p className="mt-1 mb-0">
							<span className={"inline-flex items-center text-xs font-semibold rounded-full px-3 py-1 " + ((is_list) ? "bg-purple-50 text-purple-700" : "bg-green-50 text-green-700")}>
								<span className={"w-1.5 h-1.5 rounded-full mr-1.5 " + ((is_list) ? "bg-purple-500" : "bg-green-500")} aria-hidden="true"></span>
								{(is_list) ? "Liste" : "Page"}
							</span>
						</p>
					</div>
				</div>
				{(is_list) ?
					<Lists
						embedded={true}
						category={category}
						navigation={[]}
						current_lang={this.state.current_lang}
						features={this.props.features}
						icons={this.state.icons}
						langs={this.props.langs}
						lang_default={this.props.lang_default}
						lists={this.props.lists}
						pages={this.props.pages}
						services={this.props.services}
						theme={this.state.theme}
						fetchPageByID={this.props.fetchPageByID}
						fetchListByCategory={this.props.fetchListByCategory}
						fetchServices={this.props.fetchServices}
						insertListElement={this.props.insertListElement}
						insertPage={this.props.insertPage}
						insertPageSection={this.props.insertPageSection}
						updateListCover={this.props.updateListCover}
						updateListElement={this.props.updateListElement}
						updateListOrderElements={this.props.updateListOrderElements}
						updateListTransformSubcategory={this.props.updateListTransformSubcategory}
						updatePageCover={this.props.updatePageCover}
						updatePageDuplicateSection={this.props.updatePageDuplicateSection}
						updatePageName={this.props.updatePageName}
						updatePageOrderSections={this.props.updatePageOrderSections}
						updatePageSection={this.props.updatePageSection}
						updatePageService={this.props.updatePageService}
						deleteListElement={this.props.deleteListElement}
						deletePage={this.props.deletePage}
						deletePageSection={this.props.deletePageSection}
						deletePageService={this.props.deletePageService}
						updateLang={this.updateLang}
						unShowGroup={this.goContenu}
						unShowCategory={this.goRubrique}
					/>
					:
					<Pages
						embedded={true}
						category={category}
						navigation={[]}
						current_lang={this.state.current_lang}
						features={this.props.features}
						icons={this.state.icons}
						langs={this.props.langs}
						lang_default={this.props.lang_default}
						pages={this.props.pages}
						services={this.props.services}
						theme={this.state.theme}
						fetchPageByCategory={this.props.fetchPageByCategory}
						fetchPageByID={this.props.fetchPageByID}
						fetchServices={this.props.fetchServices}
						insertPageSection={this.props.insertPageSection}
						updatePageCover={this.props.updatePageCover}
						updatePageDuplicateSection={this.props.updatePageDuplicateSection}
						updatePageOrderSections={this.props.updatePageOrderSections}
						updatePageSection={this.props.updatePageSection}
						updatePageService={this.props.updatePageService}
						deletePageSection={this.props.deletePageSection}
						deletePageService={this.props.deletePageService}
						updateLang={this.updateLang}
						unShowGroup={this.goContenu}
						unShowCategory={this.goRubrique}
					/>
				}
			</div>
		)
	}
}

export default ContenuCategorie
